"use strict";

function init() {
	$('#fullSizeModal').on('show.bs.modal', function (e) {
		$("img[data-src^='fullSizeModal-src']").attr('src', e.relatedTarget.src);
		$('#fullSizeModal-Label').text(e.relatedTarget.alt);
	});
}

module.exports = {
	init
};


// WEBPACK FOOTER //
// ./src/scripts/client/plugin/gallery.js